import React from "react";
import { graphql } from "gatsby";
import BackButton from "../../components/BackNavigation/BackButton";

function BackButtonSection({ label, path }) {
  return <BackButton to={path}>{label || "Back"}</BackButton>;
}

export default React.memo(BackButtonSection);

export const SpacerFragment = graphql`
  fragment BackButtonFragment on DatoCmsCModuleBackButton {
    label
    path
    container
    innerContainer
    containerDisableGutters
    containerBackgroundColor
    model {
      apiKey
    }
  }
`;
